// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LzA_","largestCol":"styles_largestCol__14tL1","smallestCol":"styles_smallestCol__1t1aw"};